import { MarkdownRendererInlineEdit } from '.';

const markdown = `
# Heading 1

This is a paragraph.

## Heading 2

This is a paragraph with a **bold**, _italic_ and ~~deleted text~~ text in the middle.

### Regular unordered list (heading 3)

- list
- list2

#### Regular ordered list (heading 4)

1. list
2. list2

##### Task list (heading 5)

- [ ] Irure anim minim magna anim in irure et adipisicing cupidatat adipisicing quis enim nisi nostrud voluptate. Reprehenderit non sunt ipsum reprehenderit quis tempor occaecat culpa. Occaecat amet consectetur sit velit est ea quis incididunt ad dolor nostrud anim. Proident ullamco elit anim tempor duis in aliqua cillum anim do. Reprehenderit fugiat dolor minim elit occaecat excepteur minim non.

- [x] bar

###### Table (heading 6)

| Header | Header |
| ------ | ------ |
| Body   | Body   |
| Body   | Body   |

`;

export const MarkdownRendererInlineEditExample = () => {
  return (
    <MarkdownRendererInlineEdit
      editable
      markdown={markdown}
      placeholder="Adicionar descrição"
    />
  );
};
